// extracted by mini-css-extract-plugin
export default {"root":"UsersGroupsTable_root__ID3qn","row":"UsersGroupsTable_row__gJCtg","boxMargin":"UsersGroupsTable_boxMargin__KP27i","fullHeight":"UsersGroupsTable_fullHeight__C+D57"};